import { createSlice } from '@reduxjs/toolkit';

import { initFinished, initSucceeded } from '../../actions/cruiseListActions';

// `initialized` gates the loader and is set by `initFinished`, which fires on every exit — so the
// list appears even when the search failed. Both actions are shared, dispatched by the thunk.

const cruisesSlice = createSlice({
  name: 'cruises',
  initialState: {
    initialized: false,
    cruises: [],
    searchInformation: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(initFinished, (state) => {
        state.initialized = true;
      })
      .addCase(initSucceeded, (state, action) => {
        state.cruises = action.payload.cruises;
        state.searchInformation = action.payload.searchInformation;
      });
  },
});

export default cruisesSlice.reducer;
